import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './ApplicantDetails.css';
import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { isEmpty } from 'lodash';
import { TextInput, Select, Phone, Checkbox, RadioButtons } from './components/FormFields';
import ActionsPanel from '../ActionsPanel';
import { getDictionaryItem, get } from '../../../../utils';
import { IconWarning } from '../../../atoms/Icons/';
import { SaveLongTourismEntryPermit } from '../actions';
import { formatDistanceToNowStrict } from 'date-fns';
import { uploadConsent } from '../actions';
var StepRender = function StepRender(props) {
  var context = props.context,
    updateContext = props.updateContext,
    updateSteps = props.updateSteps,
    currentStepId = props.currentStepId,
    stepConfig = props.stepConfig,
    _props$rtl = props.rtl,
    rtl = _props$rtl === void 0 ? false : _props$rtl,
    setTranslateValue = props.setTranslateValue,
    getTranslateValue = props.getTranslateValue,
    generateStepData = props.generateStepData,
    validateCurrentFields = props.validateCurrentFields,
    getLookupOptions = props.getLookupOptions,
    setApplicationNumber = props.setApplicationNumber,
    setDocuments = props.setDocuments,
    appRef = props.appRef,
    apiConfig = props.apiConfig,
    applicationNumber = props.applicationNumber,
    isTranslateAvaible = props.isTranslateAvaible,
    isLoadingWizard = props.isLoadingWizard;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    validate = _useState2[0],
    setValidate = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorServerMessage = _useState4[0],
    setErrorServerMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRequesting = _useState6[0],
    setIsRequesting = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    validForm = _useState8[0],
    setValidForm = _useState8[1];
  var isChildrenApp = useMemo(function () {
    if (!context['birthDate'] || !context['birthDate'].value || !context['birthDate'].value.length) return false;
    var parsedDate = new Date(context['birthDate'].value.replaceAll('-', '/'));
    console.log(parsedDate, context['birthDate'].value);
    var getyears = parseFloat(formatDistanceToNowStrict(parsedDate));
    return getyears < 18;
  }, [context]);
  var _stepConfig$data = stepConfig.data,
    title = _stepConfig$data.title,
    adPersonalDetailsTitle = _stepConfig$data.adPersonalDetailsTitle,
    adContactDetailsTitle = _stepConfig$data.adContactDetailsTitle,
    adContactDetailsMessage = _stepConfig$data.adContactDetailsMessage,
    adInfoMessage = _stepConfig$data.adInfoMessage,
    adMessage = _stepConfig$data.adMessage,
    policyMessage = _stepConfig$data.policyMessage,
    countriesList = _stepConfig$data.countriesList,
    buttonBackUrl = _stepConfig$data.buttonBackUrl,
    dictionary = stepConfig.dictionary,
    validateMessage = stepConfig.validateMessage,
    dictionaryNavigation = stepConfig.dictionaryNavigation;
  // const [context, setContext] = useState({});
  var history = useHistory();
  var nextStepId = currentStepId + 1;
  var prevStepId = currentStepId - 1;
  var fieldsList = [{
    apiName: '',
    name: 'IAgreeThatProvidedContact',
    type: 'checkbox',
    required: isChildrenApp
  }, {
    apiName: 'isInsideUAE',
    name: 'Applicant',
    type: 'radio',
    required: true
  }, {
    apiName: 'motherNameEN',
    name: 'MotherNameEnglish',
    type: 'text',
    required: true,
    relatedFieldName: 'motherNameAR'
  }, {
    apiName: 'motherNameAR',
    name: 'MotherNameArabic',
    type: 'text',
    required: true,
    relatedFieldName: 'motherNameEN'
  }, {
    apiName: 'maritalStatusId',
    name: 'MaritalStatus',
    type: 'select',
    required: true
  }, {
    apiName: 'religionId',
    name: 'Religion',
    type: 'select',
    required: true
  }, {
    apiName: 'FaithId',
    name: 'Faith',
    type: 'select',
    required: true
  }, {
    apiName: 'educationId',
    name: 'Education',
    type: 'select',
    required: true
  }, {
    apiName: 'professionId',
    name: 'Profession',
    type: 'select',
    required: true
  }, {
    apiName: 'languageId',
    name: 'FirstLanguage',
    type: 'select',
    required: true
  }, {
    apiName: 'arrivalCountryId ',
    name: 'ComingFromCountry',
    type: 'select',
    required: true
  }, {
    apiName: 'bankStatementCountryId',
    name: 'BankStatementCountry',
    type: 'select',
    required: true
  }, {
    apiName: 'email',
    name: 'Email',
    type: 'email',
    required: true
  }, {
    apiName: '',
    name: 'ConfirmEmail',
    type: 'email',
    required: true
  },
  // { apiName: 'mobileNo', name: 'MobileNumber', type: 'phone', required: true },
  // { apiName: 'preferredSmsLanguage', name: 'PreferredSMSLanguage', type: 'select', required: true },

  {
    apiName: 'emirateId',
    name: 'Emirate',
    type: 'select',
    required: true
  }, {
    apiName: 'cityId',
    name: 'City',
    type: 'select',
    required: true
  }, {
    apiName: 'areaId',
    name: 'Area',
    type: 'select',
    required: true
  }, {
    apiName: 'street',
    name: 'Street',
    type: 'text',
    required: true
  }, {
    apiName: 'building',
    name: 'BuildingVilla',
    type: 'text',
    required: true
  }, {
    apiName: '',
    name: 'Floor',
    type: 'text'
  }, {
    apiName: '',
    name: 'FlatVillaNumber',
    type: 'text'
  }, {
    apiName: 'landmark',
    name: 'Landmark',
    type: 'text'
  }, {
    apiName: 'makaniNo',
    name: 'MakaniNumber',
    type: 'text'
  }, {
    apiName: 'addressOutsideCountryId',
    name: 'Country',
    type: 'select',
    required: true
  }, {
    apiName: 'addressOutsideCity',
    name: 'City',
    replacedFieldName: 'outsideCity',
    type: 'text',
    required: true
  }, {
    apiName: 'addressOutsideTelNo',
    name: 'MobileNumber',
    replacedFieldName: 'outsideMobileNumber',
    type: 'phone',
    required: true
  }, {
    apiName: 'addressOutside1',
    name: 'Address',
    type: 'text',
    required: true
  }, {
    apiName: 'addressOutside2',
    name: 'Address2',
    type: 'text',
    required: true,
    staticName: 'Address Outside 2 * (static label)'
  }, {
    apiName: 'visitReason',
    name: 'VisitReason',
    type: 'select',
    required: true,
    staticName: 'Visit Reason * (static label)'
  }, {
    apiName: 'visitDuration',
    name: 'VisitDuration',
    type: 'select',
    required: true,
    staticName: 'Visit Duration * (static label)'
  }
  // {
  //   apiName: 'entryType',
  //   name: 'EntryType',
  //   type: 'select',
  //   required: true,
  //   staticName: 'Entry Type * (static label)',
  // },
  ];
  var dashboardUrl = get(buttonBackUrl, 'jss.value.href') || '/';
  var warningMessage = get(adMessage, 'jss');
  var panelButtonState = {
    continue: {
      inactive: !validForm,
      loading: isLoadingWizard || isRequesting,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationContinue')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: !validForm,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSave')
    }
  };
  var submitData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(isDraft, appId) {
      var _yield$SaveLongTouris, _yield$SaveLongTouris2, applicationNumber, _yield$SaveLongTouris3, documents, _yield$SaveLongTouris4, isSuccess, error, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setErrorServerMessage('');
            setIsRequesting(true);
            _context.next = 4;
            return SaveLongTourismEntryPermit(apiConfig, context, isDraft, appId);
          case 4:
            _yield$SaveLongTouris = _context.sent;
            _yield$SaveLongTouris2 = _yield$SaveLongTouris.applicationNumber;
            applicationNumber = _yield$SaveLongTouris2 === void 0 ? '' : _yield$SaveLongTouris2;
            _yield$SaveLongTouris3 = _yield$SaveLongTouris.documents;
            documents = _yield$SaveLongTouris3 === void 0 ? [] : _yield$SaveLongTouris3;
            _yield$SaveLongTouris4 = _yield$SaveLongTouris.isSuccess;
            isSuccess = _yield$SaveLongTouris4 === void 0 ? false : _yield$SaveLongTouris4;
            error = _yield$SaveLongTouris.error;
            console.log('error', error);
            setIsRequesting(false);
            if (isEmpty(error)) {
              _context.next = 18;
              break;
            }
            errorMessage = rtl && error.ar ? error.ar : error.en || '';
            setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
            return _context.abrupt("return", false);
          case 18:
            if (!(isSuccess && applicationNumber.length)) {
              _context.next = 22;
              break;
            }
            setApplicationNumber(applicationNumber);
            setDocuments(documents);
            return _context.abrupt("return", true);
          case 22:
            return _context.abrupt("return", false);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function submitData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var sendParentalConsent = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (isChildrenApp) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", false);
          case 2:
            _context2.next = 4;
            return uploadConsent({
              apiKey: apiConfig.apiKey,
              sessionId: apiConfig.sessionId
            }, {
              uuids: {
                email: String(context['email'].value || '').toLocaleLowerCase()
              },
              activity_timestamp: Math.floor(Date.now() / 1000),
              consent_source: 'GDRFA Project',
              custom_parameters: {
                FirstName: context['firstNameEN'] ? context['firstNameEN'].value : '',
                LastName: context['lastNameEN'] ? context['lastNameEN'].value : '',
                PhoneNumber: "".concat(context['addressOutsideTelNo'].code).concat(context['addressOutsideTelNo'].value),
                City: context['addressOutsideCity'] ? context['addressOutsideCity'].value : '',
                FormURL: window.location.href
              },
              consent_info: [{
                processing_purpose_id: 6,
                processing_purpose_name: "Parental consent for collection of Minor's details",
                consented_items: [{
                  consent_purpose_id: 11,
                  consent_granted: context['IAgreeThatProvidedContact'].value ? true : false
                }]
              }]
            });
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function sendParentalConsent() {
      return _ref2.apply(this, arguments);
    };
  }();
  var panelActions = {
    contionueAction: function () {
      var _contionueAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var success;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(validateCurrentFields && validateCurrentFields(fieldsList))) {
                _context3.next = 3;
                break;
              }
              setValidate(true);
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return sendParentalConsent();
            case 5:
              _context3.next = 7;
              return submitData(false, applicationNumber);
            case 7:
              success = _context3.sent;
              if (success) updateSteps(nextStepId);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function contionueAction() {
        return _contionueAction.apply(this, arguments);
      }
      return contionueAction;
    }(),
    saveAction: function () {
      var _saveAction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var success;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(validateCurrentFields && validateCurrentFields(fieldsList))) {
                _context4.next = 3;
                break;
              }
              setValidate(true);
              return _context4.abrupt("return");
            case 3:
              _context4.next = 5;
              return sendParentalConsent();
            case 5:
              _context4.next = 7;
              return submitData(false, applicationNumber);
            case 7:
              success = _context4.sent;
              if (success) history.push(dashboardUrl);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function saveAction() {
        return _saveAction.apply(this, arguments);
      }
      return saveAction;
    }(),
    backAction: function backAction() {
      updateSteps(prevStepId);
    }
  };
  useEffect(function () {
    generateStepData && generateStepData(fieldsList, dictionary);
    appRef && appRef.current.scrollIntoView({
      behavior: 'smooth'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (validateCurrentFields && !validateCurrentFields(fieldsList)) setValidForm(true);else setValidForm(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: " module-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'h2',
    field: title || {
      value: ''
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'h4  col-md-12',
    field: {
      value: getDictionaryItem(dictionary, 'IsTheApplicantInsideTheUAE') || 'Is the applicant Inside the UAE? *'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "  col-md-12  form-field"
  }, /*#__PURE__*/React.createElement(RadioButtons, _extends({}, context['isInsideUAE'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('insideOutsideCountry') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "  col-md-12  form-field"
  }, warningMessage && /*#__PURE__*/React.createElement("div", {
    className: "field__info-box"
  }, /*#__PURE__*/React.createElement(IconWarning, null), /*#__PURE__*/React.createElement(RichText, {
    field: warningMessage
  })), /*#__PURE__*/React.createElement(RichText, {
    field: get(adInfoMessage, 'jss'),
    className: "field__info"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: 'h3 title col-md-12 ',
    field: {
      value: get(adPersonalDetailsTitle, 'jss.value') || ' '
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    setTranslateValue: setTranslateValue
  }, context['motherNameEN'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    getTranslateValue: getTranslateValue,
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage
  }, context['motherNameAR'], {
    isTranslateAvaible: isTranslateAvaible,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['maritalStatusId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('listofMaritalStatus') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['religionId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('religions') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['FaithId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    parentDependent: true,
    parentValueId: context['religionId'] && context['religionId'].value,
    options: getLookupOptions && getLookupOptions('faiths') || []
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['educationId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('education') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['professionId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('profession') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['languageId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('language') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['arrivalCountryId '], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['bankStatementCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['visitReason'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('visitReasons') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['visitDuration'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('visitDuration') || [],
    rtl: rtl
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: 'h3 title col-md-12 ',
    field: {
      value: get(adContactDetailsTitle, 'jss.value') || 'Is the applicant Inside the UAE? *'
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: 'description  col-md-12 ',
    field: {
      value: get(adContactDetailsMessage, 'jss.value') || ' '
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['email'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage
  }, context['ConfirmEmail'], {
    confirmField: context['email'] && context['email'].value,
    rtl: rtl
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'h4 sub-title col-md-12 ',
    field: {
      value: getDictionaryItem(dictionary, 'AddressInsideUAE') || 'Address inside UAE'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['emirateId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('emirates') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['cityId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    parentDependent: true,
    parentValueId: context['emirateId'] && context['emirateId'].value,
    options: getLookupOptions && getLookupOptions('cities') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['areaId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    parentDependent: true,
    parentValueId: context['cityId'] && context['cityId'].value,
    options: getLookupOptions && getLookupOptions('areas') || [],
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['street'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['building'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['Floor'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['FlatVillaNumber'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['landmark'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['makaniNo'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: 'h4 sub-title col-md-12 ',
    field: {
      value: getDictionaryItem(dictionary, 'AddressOutsideUAE') || 'Address outside UAE'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(Select, _extends({
    rtl: rtl
  }, context['addressOutsideCountryId'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    options: getLookupOptions && getLookupOptions('country') || []
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['addressOutsideCity'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, context['addressOutsideTelNo'] && /*#__PURE__*/React.createElement(Phone, _extends({}, context['addressOutsideTelNo'], {
    countryValues: countriesList,
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    isDisablePlus: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['addressOutside1'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6  form-field"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['addressOutside2'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl
  }))), isChildrenApp && /*#__PURE__*/React.createElement("div", {
    className: " col-md-12  form-field"
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, context['IAgreeThatProvidedContact'], {
    updateContext: updateContext,
    validate: validate,
    patternInvalidMessage: validateMessage,
    rtl: rtl,
    required: isChildrenApp
  })))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : ''), /*#__PURE__*/React.createElement("div", {
    className: "module-group-wrap"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: get(policyMessage, 'jss'),
    className: "field__info"
  }))), /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActions,
    buttonState: panelButtonState
  }));
};
var commonStyles = "cjru4lo";
var rtlStyles = "r1hz6bq7";
var ltrStyles = "l182eywu";
export default StepRender;